import { ICompany } from 'app/shared/model/company.model';
import { IInspectionItemPerformed } from 'app/shared/model/inspection-item-performed.model';
import { IInspection } from 'app/shared/model/inspection.model';

export interface IInspectionItem {
  id?: number;
  name?: string | null;
  description?: string | null;
  company?: ICompany | null;
  inspectionItemPerformeds?: IInspectionItemPerformed[] | null;
  inspections?: IInspection[] | null;
}

export const defaultValue: Readonly<IInspectionItem> = {};
